import React, { FC } from "react"
import Img from "gatsby-image"
import styled, { CSSProperties } from "styled-components"

const StyledImg = styled<any>(Img)`
  max-width: ${({ width }) => (width && width !== 0 ? `${width}px` : "100%")};
  width: 100%;
`

type Props = {
  width?: number
  style?: CSSProperties
  img: {
    fluid: {
      aspectRatio: number
      src: string
      srcSet: string
      sizes: string
      base64?: string
      tracedSVG?: string
      srcWebp?: string
      srcSetWebp?: string
      media?: string
    }
    title: string
  }
}

const ImgWrapper: FC<Props> = ({ width, img, style }) => {
  return img === undefined || img === null ? (
    <div>No image</div>
  ) : (
    <StyledImg
      style={style}
      alt={img.title}
      width={width}
      fluid={{ ...img.fluid }}
      loading="lazy"
    />
  )
}

export default ImgWrapper
